webpackJsonp([60323799685267],{

/***/ 1214:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CardconnectSurchargeStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":"How the merchant account's surcharge configuration reads to a client-facing screen","enumValues":[{"deprecationReason":null,"description":"A surcharge rate is configured and usable","isDeprecated":false,"name":"ACTIVE"},{"deprecationReason":null,"description":"The merchant account does not surcharge","isDeprecated":false,"name":"NOT_ENABLED"},{"deprecationReason":null,"description":"Surcharging is on but the reported rate cannot be displayed","isDeprecated":false,"name":"UNUSABLE_RATE"},{"deprecationReason":null,"description":"Surcharging is on but the reported rate is zero","isDeprecated":false,"name":"ZERO_RATE"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-cardconnect-surcharge-status-44ce43114d3b63a69305.js